import "@fontsource/montserrat/";
import "@fontsource/cabin/";

const fonts = {
    heading: "Montserrat",
    body: "Cabin",
};

export default fonts;
